// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__11Qj-","content":"DefaultLayout_content__KXu3E"};